export default __webpack_public_path__ + "static/media/kaffa-mobile.ca2ffb89.svg";